import React from 'react';
import ArticleImageCarousel from '@/components/shared/ArticleImageCarousel'; // Import the new component

export const BerattelseStyles = {
  articleContainer: "prose lg:prose-xl max-w-none prose-p:leading-loose prose-li:leading-loose",
  introduction: "lead text-gray-700 font-medium text-lg md:text-xl mb-4", // Adjusted introduction style
  heading: "text-minnestig-teal font-bold mt-8 mb-4", // Increased top margin for headings
  paragraph: "text-gray-700 mb-4", // Slightly darker paragraph text
  list: "list-disc list-inside text-gray-700 mb-4", // Slightly darker list text
};

// Define a more specific type for sections if possible, or use a general one
interface Section {
  type: 'heading' | 'paragraph' | 'list' | 'imageCarousel';
  content?: string;
  level?: number;
  items?: string[];
  images?: string[];
}

export const StyledArticle = ({ introduction, sections }: { introduction: string; sections: Section[] }) => (
  <article className={BerattelseStyles.articleContainer}>
    {introduction && <p className={BerattelseStyles.introduction}>{introduction}</p>}
    {sections.map((section, index) => {
      if (section.type === 'heading' && section.content) {
        const Tag = `h${section.level || 2}` as keyof JSX.IntrinsicElements;
        return <Tag key={index} className={`${BerattelseStyles.heading} ${section.level === 2 ? 'text-2xl md:text-3xl' : 'text-xl md:text-2xl'}`}>{section.content}</Tag>;
      }
      if (section.type === 'paragraph' && section.content) {
        return <p key={index} className={BerattelseStyles.paragraph} dangerouslySetInnerHTML={{ __html: section.content }}></p>;
      }
      if (section.type === 'list' && section.items) {
        return (
          <ul key={index} className={BerattelseStyles.list}>
            {section.items.map((item, itemIndex) => (
              <li key={itemIndex} dangerouslySetInnerHTML={{ __html: item.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}></li>
            ))}
          </ul>
        );
      }
      if (section.type === 'imageCarousel' && section.images) {
        // Render the ArticleImageCarousel for 'imageCarousel' type
        return <ArticleImageCarousel key={index} images={section.images} />;
      }
      return null;
    })}
  </article>
);
